import PropTypes from 'prop-types';
import styles from './FJMyCreations.module.less';
import FJBlankPanel from '../../../../FJMainPreview/FJBlankPanel/FJBlankPanel';
import FJLocalStore from '../../../../../store/FJLocalStore';
import NoContentIcon from '../../../../../assets/svg/no-content.svg?react';
import FJButton, { FJButtonType } from '../../../../../common/components/FJButton/FJButton.jsx';
import GoToGenerateIcon from '../../../../../assets/svg/community/go-to-generate.svg?react';
import FJPanelCategoryList from '../../../../../common/components/FJPanelCategoryList/FJPanelCategoryList';
import FJSkeletonScreen from '../../../../../common/components/FJSkeletonScreen/FJSkeletonScreen.jsx';
import { MY_SPACE_SKELETON_SCREEN_LIST } from '../../../../../config/dataConfig/FJCommunityData.js';
import FJCommunityWorkItemContainer from '../../../FJCommonComponent/FJCommunityWorkItem/FJCommunityWorkItemContainer.jsx';
import FJDropDownManager from '../../../../../common/js/FJDropDownManager.js';
const PREVIEW_ITEM_HEIGHT = 168;
const IMAGE_SPACE = 12;
const FJMyCreations = props => {
    const { active, myCreationsList, seeAll, myCreationsPageLoading, changeNavBarToAIList } = props;
    const onGenerateNow = () => {
        changeNavBarToAIList();
    };
    const onScrollStart = () => {
        FJDropDownManager.hideAll();
    };
    const renderMediaItem = item => {
        const { width: itemWidth, height: itemHeight } = item;
        const ratio = itemWidth / itemHeight || 16 / 9;
        const height = PREVIEW_ITEM_HEIGHT;
        const width = height * ratio;
        return (
            <div style={{ width, height: PREVIEW_ITEM_HEIGHT, marginRight: IMAGE_SPACE, position: 'relative' }}>
                <FJCommunityWorkItemContainer item={item} active={active} />
            </div>
        );
    };
    const _renderEmpty = () => {
        return (
            <FJBlankPanel icon={<NoContentIcon />} text={FJLocalStore._('no-creations-yet')}>
                <FJButton
                    className={styles.create_button}
                    text={FJLocalStore._('generate-now')}
                    onClick={onGenerateNow}
                    type={FJButtonType.GRADIENT}
                    icon={<GoToGenerateIcon className={styles.generate_icon} />}
                />
            </FJBlankPanel>
        );
    };
    const _renderList = () => {
        return (
            <FJPanelCategoryList
                boxClass={styles.list}
                scrollerClassName={styles.scroller}
                data={myCreationsList}
                previewItemHeight={PREVIEW_ITEM_HEIGHT}
                moreButtonHeight={PREVIEW_ITEM_HEIGHT}
                seeAll={seeAll}
                renderItem={renderMediaItem}
                onScrollStart={onScrollStart}
                categoryStyle={{ marginBottom: '24px' }}
            />
        );
    };
    if (!active) return null;
    if (myCreationsPageLoading) {
        return (
            <div className={styles.skeleton_screen}>
                <FJSkeletonScreen list={MY_SPACE_SKELETON_SCREEN_LIST} />
            </div>
        );
    }
    return myCreationsList.length ? _renderList() : _renderEmpty();
};

FJMyCreations.propTypes = {
    active: PropTypes.bool,
    myCreationsList: PropTypes.array,
    seeAll: PropTypes.func,
    myCreationsPageLoading: PropTypes.bool,
    changeNavBarToAIList: PropTypes.func,
};

export default FJMyCreations;
